import {useEffect} from "react";

/**
 * Registers `window.continueJetIframe` so Paycomet calls it after tokenizing
 * the card data instead of submitting the form.
 *
 * @param onToken  Called with the paytpvToken once Paycomet resolves it.
 * @param onError  Optional — called when the token is missing after tokenization.
 */
const usePaycometToken = (
    onToken: (token: string) => void,
    onError?: (msg: string) => void,
) => {
    useEffect(() => {
        (window as any).continueJetIframe = () => {
            const form = document.getElementById("paycometPaymentForm") as HTMLFormElement | null;
            const token = form?.querySelector<HTMLInputElement>('input[name="paytpvToken"]')?.value;

            if (!token) {
                const msg = "[Paycomet] No se encontró paytpvToken en el formulario";
                onError?.(msg);
                return;
            }

            onToken(token);
        };

        return () => {
            delete (window as any).continueJetIframe;
        };
    }, [onToken, onError]);
};

export default usePaycometToken;

